import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { SseService } from '@ortho-next/sse';
import { timer } from 'rxjs';
import { first, take, takeWhile } from 'rxjs/operators';
import { APP_CONFIG, LoaderService, ToastService } from '../../core';
import { CaseService, ModelService } from '../../services';
import { BaseComponent } from '../../shared';


/**
* Component of first vertical sidebar tool menu to reverse planning method.
*/
@Component({
	selector: 'rpm-menu',
	templateUrl: './rpm-menu.component.html',
	changeDetection: ChangeDetectionStrategy.Eager
})
export class RpmMenuComponent extends BaseComponent implements OnInit {

	private readonly config = inject(APP_CONFIG);
	private readonly sseSrv = inject(SseService);
	private readonly planSrv = inject(CaseService);
	private readonly toastSrv = inject(ToastService);
	private readonly modelSrv = inject(ModelService);
	private readonly loaderSrv = inject(LoaderService);

	private _resetKey: string | null = null;
	private _isReadOnly = false;


	ngOnInit(): void {
		this.planSrv.isReadOnly().pipe(first(res => res != null)).subscribe(res => this._isReadOnly = res);
	}

	/**
	* Display RPM menu tools.
	*/
	enableRPM(): void {
		if (this.isDeformityDone) {
			this.goToReversePlanning();
		}
	}

	private goToReversePlanning(): void {
		const currentCase = this.canvasSrv.currentCase!;
		this.canvasSrv.dispatch('switchToRPM');
		if (!this._isReadOnly) {
			this.loaderSrv.show();
			this.handleModelReset(currentCase.id);
			this.modelSrv.persistModel(currentCase.id, currentCase.userGuid).subscribe({
				error: () => {
					this.backToDeformity();
					this._clearResetEvents();
				}
			});
		}
	}

	private backToDeformity(): void {
		this.toastSrv.showWarning(this.labels().TOOLS_MENU_COMPONENT_PLAN_SAVED_ERROR);
		this.canvasSrv.dispatch('switchToDeformity');
		this.loaderSrv.hide();
	}

	private _clearResetEvents(): void {
		if (this._resetKey) {
			this.sseSrv.unsubscribe(this._resetKey);
			this._resetKey = null;
		}
	}

	private handleModelReset(planId: string): void {
		this._resetKey = `OrthoNext.Fibone.Reset.${planId}`;
		console.log('Resetting... ' + this._resetKey);
		this.sseSrv.subscribe(this._resetKey, (success: boolean) => {
			console.log('Resetted: ' + success);
			if (success) {
				this.redirectToFitbone();
			} else {
				this.backToDeformity();
				this._clearResetEvents();
			}
		});
		// timeout reset subscription
		timer(0, this.config.resetSubscriptionTimeout / 10).pipe(
			takeWhile(() => !!this._resetKey),
			take(10),
		).subscribe({
			complete: () => {
				if (this._resetKey) {
					console.log('Not Resetted');
					this.backToDeformity();
					this._clearResetEvents();
				}
			}
		});
	}

	/**
	 * Redirect to fitbone site.
	 */
	redirectToFitbone(): void {
		globalThis.location.href = `${this.config.templatesSite}?caseGuid=${this.canvasSrv.currentCase!.id}`;
	}

}
